import { getPropertyPublishStatus, publishProperty } from '../../api'

// Used to block parallel publish status refresh requests
// Also resets the state when the PropertyPage component is unmounted
const abortControllers = {
  refreshAbortController: null,
  publishAbortController: null,
}

const setHasUnpublishedChanges = function (hasUnpublishedChanges) {
  abortControllers.refreshAbortController?.abort()
  return {
    type: 'PROPERTY_SET_UNPUBLISHED_CHANGES',
    payload: hasUnpublishedChanges,
  }
}

const setIsPublishBlockedDueToUnconfirmedImages = blocked => ({
  type: 'PROPERTY_SET_IS_PUBLISH_BLOCKED_UNCONFIRMED_IMAGES',
  payload: blocked,
})

const setPublishInProgress = (publishInProgress) => ({
  type: 'PROPERTY_PUBLISH_IN_PROGRESS',
  payload: publishInProgress,
})

const setFailedToPublish = (failedToPublish) => ({
  type: 'PROPERTY_SET_FAILED_TO_PUBLISH',
  payload: failedToPublish,
})

const refreshPublishStatus = (giataId) => {
  return (dispatch) => {
    abortControllers.refreshAbortController?.abort()
    abortControllers.refreshAbortController = new AbortController()
    getPropertyPublishStatus(giataId, abortControllers.refreshAbortController).then((response) => {
      dispatch(setHasUnpublishedChanges(response.hasUnpublishedChanges))
    }).catch((error) => {
      console.error('Failed to refresh property publish status, ' + error)
    })
  }
}

const publish = (giataId) => {
  return (dispatch) => {
    abortControllers.publishAbortController?.abort()
    abortControllers.publishAbortController = new AbortController()
    dispatch(setPublishInProgress(true))
    publishProperty(giataId, abortControllers.publishAbortController).then(_ => {
      dispatch(setHasUnpublishedChanges(false))
      dispatch(setFailedToPublish(false))
    }).catch((error) => {
      dispatch(setFailedToPublish(true))
      console.error('Failed to publish property, ' + error)
    }).finally(() => {
      dispatch(setPublishInProgress(false))
    })
  }
}

export const propertyActions = {
  setHasUnpublishedChanges,
  refreshPublishStatus,
  publish,
  setPublishInProgress,
  setIsPublishBlockedDueToUnconfirmedImages,
  setFailedToPublish,
}
